import React from 'react'

const services = [
  {
    icon: <i class='fas fa-laptop-code'></i>,
    title: 'Custom Software Development',
    desc: 'We build tailored software solutions designed to address your specific business challenges and requirements.',
  },
  {
    icon: <i class='fas fa-mobile-alt'></i>,
    title: 'Mobile App Development',
    desc: 'Create engaging mobile applications for iOS and Android platforms that connect you with your customers.',
  },
  {
    icon: <i class='fas fa-globe'></i>,
    title: 'Web Application Development',
    desc: 'Develop responsive and scalable web applications that provide seamless user experiences across all devices.',
  },
  {
    icon: <i class='fas fa-database'></i>,
    title: 'Database Management',
    desc: 'Design and implement robust database solutions to efficiently manage and secure your business data.',
  },
  {
    icon: <i class='fas fa-cloud'></i>,
    title: 'Cloud Solutions',
    desc: 'Migrate your operations to the cloud with our secure and scalable cloud infrastructure solutions.',
  },
  {
    icon: <i class='fas fa-cogs'></i>,
    title: 'System Integration',
    desc: 'Seamlessly integrate new software with your existing systems to create a unified technology ecosystem.',
  },
]

const Services = () => (
  <section id='services' className='section services'>
    <div className='container'>
      <h2>Our Services</h2>
      <p className='lead'>
        We offer a comprehensive range of software development services to meet
        your business needs.
      </p>

      <div className='services-grid'>
        {services.map((s) => (
          <div className='service-card' key={s.title}>
            <div className='service-icon' aria-hidden>
              {s.icon}
            </div>
            <h3>{s.title}</h3>
            <p>{s.desc}</p>
          </div>
        ))}
      </div>
    </div>
  </section>
)

export default Services
